import React from 'react';
import Styled from 'styled';

import defaultStyles from './placeholder-post.scss';

export interface Props {
    styles: typeof defaultStyles;
}

class FeedPost extends React.PureComponent<Props> {
    render() {
        const { styles } = this.props;

        return (
            <div className={styles.post}>
                <div className={styles.animationWrapper}>
                    <div className={styles.filler1} />
                    <div className={styles.filler2} />
                    <div className={styles.filler3} />
                    <div className={styles.filler4} />
                    <div className={styles.filler5} />
                    <div className={styles.filler6} />
                    <div className={styles.filler7} />
                    <div className={styles.filler8} />
                    <div className={styles.filler9} />
                    <div className={styles.filler10} />
                    <div className={styles.filler11} />
                    <div className={styles.filler12} />
                </div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(FeedPost);
